/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : OauthPKCE-API.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Contains oAuth related functions.
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Vijaya Raju (H492715)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Vijaya Raju (H492715)
 * On            : May 17, 2024
 * Description   : Add 'getToken' function to get Auth Token
 *
 *
 ******************************************************************************/

import axios from 'axios';
import { EnumTokenType, IGetAuthTokenRequestArgs, IGetRefreshTokenRequestArgs, ITokenState, IUserRoleState } from 'models/auth';

export const getToken = async <T extends IGetAuthTokenRequestArgs | IGetRefreshTokenRequestArgs>(
  args: T
): Promise<ITokenState> => {
  const { type, appConfig } = args;
  const { redirect_uri, token_endpoint } = appConfig;

  let client_id = localStorage.getItem('CLIENT_ID');

  if (!client_id) {
    throw new Error('CLIENT_ID is not defined');
  } else {
    client_id = window.atob(client_id);
  }
  
  //const authorization_token = Buffer.from(`${client_id}`, 'utf8').toString('base64');
  const authorization_token = btoa(String.fromCharCode.apply(null, Array.from(new TextEncoder().encode(`${client_id}`))));
  const params = new URLSearchParams();

  params.append('redirect_uri', redirect_uri);
  params.append('code_verifier', (args as IGetAuthTokenRequestArgs).codeVerifier);

  if (type === EnumTokenType.Auth) {
    params.append('grant_type', 'authorization_code');
    params.append('code', (args as IGetAuthTokenRequestArgs).code);
  }

  const { data } = await axios.post<ITokenState>(token_endpoint, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Basic ${authorization_token}`,
    },
  });

  return data;
};
